
      import API from "!../../../../../common/temp/node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.5/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../common/temp/node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.5/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../common/temp/node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.5/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../common/temp/node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.5/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../common/temp/node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.5/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../common/temp/node_modules/.pnpm/style-loader@4.0.0_webpack@5.99.5/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/cjs.js!./widgets.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/cjs.js!./widgets.css";
       export default content && content.locals ? content.locals : undefined;
